import { Injectable } from '@angular/core';
import { Store }  from './store';

declare const moment: any;

@Injectable()
export class StoreService {

    constructor(private store: Store) { }

    isFresh(): boolean {
        const life = this.get('life');
        const timestamp = this.get('timestamp');
        const now = moment();

        return now.diff(timestamp, 'seconds') < life;
    }

    refresh() {
        this.update('timestamp', moment());
    }

    onChange(prop, callback) {
        return this.store.onChange(prop).subscribe(value => callback(value));
    }

    getStore() {
        return this.store;
    }

    get(prop) {
        return this.store.getState(prop);
    }

    add(prop, item) {
        const currentState = this.store.getState();
        const collection = currentState[prop];
        this.store.setState(Object.assign({}, currentState, {[prop]: [...collection, item]}));
    }

    remove(prop, item) {
        const currentState = this.store.getState();
        const collection = currentState[prop].filter((obj) => {
            return JSON.stringify(obj) !== JSON.stringify(item);
        });
        this.store.setState(Object.assign({}, currentState, {[prop]: [...collection]}));
    }

    delete(prop) {
        const currentState = this.store.getState();
        const collection = currentState[prop];
        this.store.setState(Object.assign({}, currentState, {[prop]: []}));
    }

    append(prop, items) {
        const currentState = this.store.getState();
        const collection = currentState[prop];
        this.store.setState(Object.assign({}, currentState, {[prop]: [...collection, ...items]}));
    }

    update(prop, item) {

        // console.log('Updating store...');
        // console.log('prop = ', prop, ' item = ', item);

        const currentState = this.store.getState();
        this.store.setState(Object.assign({}, currentState, {[prop]: item}));
    }

    findAndUpdate(prop, state) {
        const currentState = this.store.getState();
        const collection = currentState[prop];
        this.store.setState(Object.assign({}, currentState, {
            [prop]: collection.map(item => {
                if (item.id !== state.id) {
                    return item;
                }
                return Object.assign({}, item, state);
            })
        }));
    }

    findAndDelete(prop, attr, id) {
        const currentState = this.store.getState();
        const collection = currentState[prop];
        this.store.setState(Object.assign({}, currentState, {[prop]: collection.filter(item => item[attr] !== id)}));
    }

    purge() {
        this.store.purge();
    }
}



// WEBPACK FOOTER //
// /app/src/app/shared/store/store.service.ts